import React, { useContext } from 'react'
import Cam from '../img/cam.png'
import Add from '../img/add.png'
import More from '../img/more.png'
import Messages from './Messages'
import Input from './Input'
import { ChatContext } from '../context/ChatContext'

export const Chat = () => {
  const { data } = useContext(ChatContext)


  return (
    <div className='chat'>
      <div className='chat-Info'>
        <span>{data.user?.displayName}</span>
        <div className='chatIncons'>
          <img src={Cam} alt='Cam'/>
          <img src={Add} alt='add'/>
          <img src={More} alt='more'/>
        </div>
      </div>
      <Messages />
      <Input />
    </div>
  )
}
export default Chat